<b cdkFocusInitial class="block-header">{{ 'WIDGETS.ROLE' | translate }}:</b>
@for (role of roles; track role) {
    <span style="cursor: pointer; font-size: medium;"
          class="badge badge-pill m-1"
          [class]="widget?.options_dict.my_task_role.includes(role) ? 'text-bg-info' : 'text-bg-light'"
          (click)="changeSettings('my_task_role', role, widget)"
    >
        {{ 'TASKS.TEXT.ROLES.' + role | translate }}
    </span>
}
<p>
    <b class="block-header">{{ 'WIDGETS.COLUMNS' | translate }}:</b>
    <span (click)="changeSettings('columns', colon.alias, widget)"
          *ngFor="let colon of widget?.content?.colonsSettings"
          [class]="widget.options_dict.columns.includes(colon.alias) ? 'text-bg-info' : 'text-bg-light'"
          class="badge badge-pill m-1"
          style="cursor: pointer; font-size: medium;"
    >
      {{ colon.name }}
    </span>
</p>
<p>
    <app-board-select-settings
            [widget]="widget"
            [optionDictKey]="'task_board'">
    </app-board-select-settings>
</p>